import axios from 'axios'
import Router from '@/router'
// import { Loading } from 'element-ui'

export function createInstance(config) {
  const instance = axios.create({
    timeout: 30000,
    withCredentials: true,
    ...config
  })

  let loadingInstance

  const routerPath = ['/']
  const requestPath = ['applyUploadToken/jfiles_hero_weibo', 'drafts/save']

  instance.interceptors.request.use(function(config) {
    if (!requestPath.includes(config.url) && !routerPath.includes(Router.history.current.path)) {
      // 在发送请求之前做些什么
      // loadingInstance = Loading.service({
      //   fullscreen: true,
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
    }
    return config
  }, function(error) {
  // 对请求错误做些什么
    loadingInstance && loadingInstance.close()
    return Promise.reject(error)
  })

  instance.interceptors.response.use((response) => {
    setTimeout(() => {
      loadingInstance && loadingInstance.close()
    }, 300)
    const { data, config, request } = response
    if (data.status !== 200) {
      const error = Object.assign(new Error(data.message), {
        config,
        request,
        response
      })
      return Promise.reject(error)
    }
    return Promise.resolve(data.data || data)
  }, (error) => {
    setTimeout(() => {
      loadingInstance && loadingInstance.close()
    }, 100)
    return Promise.reject(error)
  })
  return instance
}
